import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { setupTranslateCrashHandler } from './libs/translateCrashHandler';
import './i18n';
import { ThemeModeProvider } from './theme/ThemeModeContext';

setupTranslateCrashHandler();

// StrictMode is intentionally NOT used here. Almost every page component
// in this codebase uses a `mountedRef` pattern (useRef(true), set false on
// unmount, checked before any setState in an async .then()) — StrictMode's
// dev-only mount->cleanup->remount double-invocation flips that ref to
// false via the phantom cleanup before any async work resolves, and it's
// never reset, permanently disabling that component's state updates (e.g.
// Plans.js gets stuck on "loading plans..." forever). This only happens
// under StrictMode in dev; a real production build never double-invokes
// effects, so this bug never fires for actual users. Confirmed 2026-09-21
// while setting up local emulator testing — see
// docs/superpowers/plans/2026-09-19-dashboard-redesign.md.
const root = createRoot(document.getElementById('root'));
root.render(
  <ThemeModeProvider>
    <App />
  </ThemeModeProvider>
);

serviceWorker.unregister();
